import { Component, Input, Output, EventEmitter } from '@angular/core';

import { EmailBoxService } from './email-box.service';
import { LogService } from './../../shared';

@Component({
  selector: 'email-box',
  template: require('./email-box.component.html'),
  styles: [require('./email-box.component.scss')],
  providers: [EmailBoxService]
})
export class EmailBoxComponent {
  @Input() set initial(emails: string) {
    this.service.email = (emails === undefined || emails === null) ? '' : emails;
    this.add();
  }

  @Output() emailsUpdated: EventEmitter<any> = new EventEmitter();

  constructor(private logger: LogService, private service: EmailBoxService) {
  }

  add() {
    this.service.emailError = '';
    this.service.add();
    this.emailsUpdated.emit(this.service.items);
  }

  remove(index: string) {
    this.service.emailError = '';
    this.service.remove(index);
    this.emailsUpdated.emit(this.service.items);
    // could use toString, but join seems safer as you set the ',' yourself
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/email-box/email-box.component.ts